var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDebit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4931_61644)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.30598 3.00781H22.694C23.4126 3.00781 24 3.59661 24 4.31384V19.6854C24 20.404 23.4125 20.9915 22.694 20.9915H1.30598C0.587438 20.9914 0 20.404 0 19.6854V4.3138C0 3.59661 0.587438 3.00781 1.30598 3.00781Z",
    fill: "#3FA9F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.12633 13.793H6.87905C7.0553 13.793 7.19869 13.9364 7.19869 14.1113V17.8653C7.19869 18.0416 7.05525 18.185 6.87905 18.185H3.12633C2.95008 18.185 2.80664 18.0416 2.80664 17.8653V14.1113C2.80669 13.9364 2.95012 13.793 3.12633 13.793Z",
    fill: "#FDC92F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6753 17.7664C20.6753 17.9527 20.5242 18.1038 20.3378 18.1038H15.54C15.3537 18.1038 15.2026 17.9527 15.2026 17.7664C15.2026 17.58 15.3537 17.4289 15.54 17.4289H20.3378C20.5242 17.4289 20.6753 17.58 20.6753 17.7664ZM20.6753 15.9644C20.6753 15.778 20.5242 15.627 20.3378 15.627H12.6207C12.4343 15.627 12.2832 15.778 12.2832 15.9644C12.2832 16.1508 12.4343 16.3019 12.6207 16.3019H20.3379C20.5242 16.3019 20.6753 16.1508 20.6753 15.9644Z",
    fill: "#EAF2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.80669 14.1728H6.52664C6.70289 14.1728 6.84628 14.3162 6.84628 14.491V18.185H6.87909C7.05534 18.185 7.19873 18.0416 7.19873 17.8653V14.1113C7.19873 13.9364 7.0553 13.793 6.87909 13.793H3.12633C2.95008 13.793 2.80664 13.9364 2.80664 14.1113L2.80669 14.1728Z",
    fill: "#FCA92A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.30541 3.00781H22.6934C23.412 3.00781 23.9994 3.59661 23.9994 4.31384V19.6854C23.9994 20.2769 23.6018 20.7797 23.0595 20.9382V5.363C23.0595 4.64441 22.472 4.05697 21.7535 4.05697H0.0253906C0.145625 3.46137 0.675641 3.00781 1.30541 3.00781Z",
    fill: "#3998DD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.95508H24V9.76653H0V5.95508Z",
    fill: "#1E3445"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0605 5.95508H24.0004V9.76653H23.0605V5.95508Z",
    fill: "#182C3B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4931_61644"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebit);
export default __webpack_public_path__ + "static/media/debit.57efd8a76400dbd26ff229387fb7c66c.svg";
export { ForwardRef as ReactComponent };